import React, { useMemo } from 'react';
import { GeoJSONLayer } from 'react-mapbox-gl';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core';
import { CoordinatesExact } from '../../models/Coordinates';
import { hexToRgba } from '../../../common/formatters/colorFormatter';

const Workzone = ({ index, coordinatesArray, visible }) => {
  const theme = useTheme();

  const sourceData = useMemo(
    () => ({
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: visible ? [coordinatesArray.map(({ longitude, latitude }) => [longitude, latitude])] : [],
      },
    }),
    [visible, coordinatesArray]
  );

  return (
    <GeoJSONLayer
      id={`workzone${index}`}
      data={sourceData}
      fillPaint={{
        'fill-color': hexToRgba(theme.palette.map.workzone, 0.4),
        'fill-outline-color': theme.palette.map.workzone,
      }}
    />
  );
};

Workzone.propTypes = {
  coordinatesArray: PropTypes.arrayOf(CoordinatesExact),
  index: PropTypes.number,
  visible: PropTypes.bool,
};

Workzone.defaultProps = {
  coordinatesArray: [],
  index: 0,
  visible: true,
};

export default React.memo(Workzone);
